import { ApplicationStore } from "Types/state";

export const errorStateSanitizer = (state: ApplicationStore) => ({
    ...state,
    account: {
        slug: state?.account?.slug,
    },
    deal: {
        ...state?.deal,
        person: {
            ...state?.deal?.person,
            zip: "-",
            credit_estimate: "-",
            first_name: "-",
            last_name: "-",
            mobile_phone: "-",
        },
    },
    creditApp: undefined,
});
